import ItemSection from 'views/enums/purchasing-stores/form/sections/item';
import CompanySection from 'views/enums/purchasing-stores/form/sections/company';
import EquivalentSection from 'views/enums/purchasing-stores/form/sections/equivalent';
import LinkSection from 'views/enums/purchasing-stores/form/sections/link';
import OceanLinkSection from 'views/enums/purchasing-stores/form/sections/ocean-link';

import itemConfig from 'views/enums/purchasing-stores/form/sections/item/config';
import companyConfig from 'views/enums/purchasing-stores/form/sections/company/config';
import linkConfig from 'views/enums/purchasing-stores/form/sections/link/config';
import oceanLinkConfig from 'views/enums/purchasing-stores/form/sections/ocean-link/config';

const config = {
  import: { component: CompanySection, formConfig: companyConfig },
  edit: { component: ItemSection, formConfig: itemConfig },
  create: { component: ItemSection, formConfig: itemConfig },
  equivalent: { component: EquivalentSection },
  link: { component: LinkSection, formConfig: linkConfig },
  'ocean-link': { component: OceanLinkSection, formConfig: oceanLinkConfig }
};

export default config;
